import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export const Canonical = () => {
  const location = useLocation();
  const canonicalUrl = `https://felgi-kordes.pl${location.pathname}`;
  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}